import React, { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'

import { selectCurrentUser } from 'store/users/users.selectors'
import { UserRole } from 'types/user'

import { getNotificationPermission, isBrowserNotificationsSupported, requestNotificationPermission } from 'utils/browser-notifications'

export const NotificationBanner: React.FC = () => {
  const currentUser = useSelector(selectCurrentUser)
  const currentUserRole = currentUser?.role

  const [notificationPermission, setNotificationPermission] = useState<NotificationPermission | 'unsupported'>(() => getNotificationPermission())

  const onEnableBrowserNotifications = useCallback(async () => {
    await requestNotificationPermission()
    setNotificationPermission(getNotificationPermission())
  }, [])

  const showNotificationBanner = currentUserRole === UserRole.CUSTOMER && isBrowserNotificationsSupported() && notificationPermission === 'default'

  return (
    <>
      {showNotificationBanner ? (
        <div
          className="alert alert-info mb-0 rounded-0 border-0 text-center"
          role="status"
          style={{ fontSize: '14px', marginLeft: '-15px', marginRight: '-15px' }}
        >
          <strong>Уведомления о смене статуса заявок.</strong> Разрешите уведомления для этого сайта.
          {/* eslint-disable-next-line react/button-has-type */}
          <button type="button" className="btn btn-sm btn-primary ml-2" onClick={onEnableBrowserNotifications}>
            Включить
          </button>
        </div>
      ) : null}
      {currentUserRole === UserRole.CUSTOMER && isBrowserNotificationsSupported() && notificationPermission === 'denied' ? (
        <div
          className="alert alert-secondary mb-0 rounded-0 border-0 small text-center"
          role="status"
          style={{ marginLeft: '-15px', marginRight: '-15px' }}
        >
          Уведомления отключены в настройках браузера. Чтобы получать оповещения о смене статуса, разрешите уведомления для этого сайта.
        </div>
      ) : null}
    </>
  )
}

export default NotificationBanner
